import { render, staticRenderFns } from "./AssignmentDetails.vue?vue&type=template&id=b3be32ee&scoped=true&"
import script from "./AssignmentDetails.vue?vue&type=script&lang=js&"
export * from "./AssignmentDetails.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentDetails.vue?vue&type=style&index=0&id=b3be32ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3be32ee",
  null
  
)

export default component.exports